import { render } from "./StatusIndicator.vue?vue&type=template&id=7889a5ea&scoped=true"
import script from "./StatusIndicator.vue?vue&type=script&lang=js"
export * from "./StatusIndicator.vue?vue&type=script&lang=js"

import "./StatusIndicator.vue?vue&type=style&index=0&id=7889a5ea&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7889a5ea"]])

export default __exports__